<template>
  <div>
    <b-button
      ref="button__back-previous"
      variant="outline-primary"
      class="ml-u8 mb-u20"
      @click="goToPreviousPage"
    >
      <span class="mr-2"> <font-awesome-icon icon="arrow-left" /> </span>
      Back to previous page
    </b-button>
    <b-container>
      <b-row class="justify-content-center">
        <b-col lg="3" xl="4">
          <div ref="text__title" class="h3 font-weight-bold mb-u4">Edit Basic Information</div>

          <FormProfileBasicInfo
            ref="formProfileBasicInfo"
            :show="showProfileProp"
            :data="user"
            :is-saving="isSaving"
            @completed="onCompleted"
            @skip="onSkip"
          >
            <template v-slot:afterForm="props">
              <div class="d-flex mt-u15 mb-u10">
                <b-button
                  ref="button__save"
                  variant="success"
                  style="width: 76px"
                  :disabled="isSaving"
                  @click="props.save"
                >
                  <b-spinner v-if="isSaving" style="width: 1rem; height: 1rem" class="" />
                  <div v-else>Save</div>
                </b-button>
                <b-button
                  ref="button__cancel"
                  variant="link"
                  class="ml-u1"
                  @click="goToPreviousPage"
                >
                  Cancel
                </b-button>
              </div>
            </template>
          </FormProfileBasicInfo>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import FormProfileBasicInfo from './components/FormProfileBasicInfo.vue';
import { userInfoMixin, notificationMixin } from '@/mixins';
import User from '@/models/User';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  components: {
    FormProfileBasicInfo,
    FontAwesomeIcon
  },
  mixins: [userInfoMixin, notificationMixin],

  data: () => ({
    showProfileProp: {
      name: false,
      surname: false,
      dateOfBirth: false,
      phoneNumber: true,
      currentOccupation: true,
      desiredOccupation: true,
      areaOfEmployment: false,
      experienceLevel: true,
      educationLevel: false,
      goals: true,
      likeToLearn: false,
      knowUsFrom: true,
      interests: true,
      completeButton: false,
      skip: false,
      age: true,
      country: true,
      company: true,
      email: true
    },
    isSaving: false
  }),

  created() {
    this.init();
  },

  methods: {
    async init() {
      // if (this.user?.know_us_from?.length > 0) {
      //   this.showProfileProp.knowUsFrom = false;
      // }
    },

    async onCompleted(payload) {
      this.isSaving = true;
      try {
        await User.api().updateUser(payload);
        this.notiSuccessDefault('update profile success.');
      } catch (error) {
        this.notiErrorDefault('something went wrong');
        console.error(error);
      }
      this.isSaving = false;
      return this.$router.push({ name: 'profile' });
    },

    onSkip() {
      this.$router.go(-1);
    },

    goToPreviousPage() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
@media (min-width: 1920px) {
  .col-xl-4 {
    min-width: 450px;
  }
}
</style>
